<template>
  <div class="wrap">
    <div class="logo_img">
      <img src="@/assets/new/login/logo.png" alt="">
    </div>
    <div class="top_title">
      <div class="title3">{{ $t('login.title') }}</div>
    </div>
    <div class="logo">
      <div class="line">
        <div class="line_1"></div>
        <div class="line_2"></div>
        <div class="line_1"></div>
      </div>
      <div class="text">{{ $t('输入账号详情') }}</div>
    </div>
    <div class="form_bar">
      <div class="inputs">
        <div v-for="(item, index) in formList" :key="index" class="input_item">
          <div class="_item">
            <input :type="item.type" :placeholder="$t(item.placeholder)" :maxlength="-1"
              v-model="form[item.key]" :adjust-position="true" />
            <i class="iconfont pwd_icons" v-if="item.key === 'password'"
              :class="item.flag === true ? 'icon-yanjing' : 'icon-yanjing-bi'" @click="handleLookPass"></i>
          </div>
        </div>
      </div>
      <div class="tips">
        <div class="tips_title">{{ $t('login.dontAccount') }}</div>
        <div class="tips_text">{{ $t('Clickhere') }}</div>
        <div class="tips_btn" @click="toRegister">{{ $t('Login.registrasi') }}</div>
      </div>
      <div class="btn_login" @click="handleLogin">{{ $t("user.Button.Two") }}</div>
    </div>
    <div class="lan_bar" v-if="verConfig.loginSetLans">
      <SetLans v-model="areaCode" />
    </div>
    <LoadingRE :show="LoadingShow" />
  </div>
</template>

<script>
import {
  Row,
  Col,
  Icon,
  Cell,
  GridItem,
  Grid,
  NavBar,
  ActionSheet,
  Button,
  Toast,
  Checkbox,
  CheckboxGroup,
  Dialog,
} from "vant";

// 设置vant的多语言
import md5 from "js-md5";
import Cookies from "js-cookie";
import { Locale } from "vant";
import enUS from "vant/lib/locale/lang/en-US";
import Modelu from "@/utils/Module";
import { getNewPhone } from "@/utils/tools";
import { mapGetters } from "vuex";

import { REQUEST_API, REQUEST_API2, REQUEST_API3 } from "@/http/api";
import { LOGIN } from "@/api";
import LoadingRE from "@/components/LoadingRE";
import AreaCodePicker from "@/components/areaCodePicker";
import LoginType from "@/components/newLoginType";
import SetLans from "@/components/setLans";
import verConfig from "@/utils/verConfig";
import i18n from "@/i18n";

const phoneItem = {
  placeholder: `${i18n.t("Login.nameInput")}`,
  icon: "icon-wode",
  type: "tel",
  key: "userName",
  length: 11,
};
const emailItem = {
  placeholder: `${i18n.t("Login.emailInput")}`,
  icon: "icon-wode",
  type: "text",
  key: "userName",
  length: 99,
  onlyEmeil: true,
};

const _currentLoginType = () => {
  if (verConfig.onlyEmailLogin) {
    return "email";
  }
  return "phone";
};

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [NavBar.name]: NavBar,
    [ActionSheet.name]: ActionSheet,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    LoadingRE,
    AreaCodePicker,
    LoginType,
    SetLans,
  },
  data() {
    return {
      loginType: 'phone',
      newLoginType: 'email',
      LoadingShow: false,
      areaCode: "",
      message: "copy",
      country: Cookies.get("language"),
      form: {
        userName: "",
        password: "",
      },
      formList: [{
        placeholder: '输入手机号',
        icon: require("@/assets/new/login/email.png"),
        key: "userName",
        type: "tel",
        length: 11,
      }, {
        placeholder: '输入密码',
        icon: require("@/assets/new/login/pwd.png"),
        key: "password",
        type: "password",
        length: 99,
        flag: false,
      }],
      tablelist: [
        // {
        //   label: `${this.$t('Login.forgot')}`,
        //   key: 'forgot',
        // },
        {
          label: `${this.$t("Login.registrasi")}`,
          key: "registrasi",
        },
      ],
      checked: false,
      thePwdObj: {
        userName: "",
        passwordL: "",
      },
      show: false,
      userAgreementChecked: true,
    };
  },
  created() {
    this.init();
  },
  methods: {
    toService() {
      this.$api.toService();
    },
    toRegister() {
      this.$router.push('/registrasi')
    },
    handleLookPass() {
      if (this.formList[1].type === "password") {
        this.formList[1].type = "text";
        this.formList[1].flag = true;
      } else {
        this.formList[1].type = "password";
        this.formList[1].flag = false;
      }
    },
    handleLogin() {
      if (!this.form.userName) return Toast(this.$t('login.phoneNumberPlaceholder'));
      if (!this.form.password) return Toast(this.$t('login.passwordPlaceholder'));
      this.login();

    },
    login() {
      let form = {
        userphone: this.form.userName,
        userpass: this.form.password,
        country_code: this.areaCode,
      };
      const emailReg =
        /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,})$/;
      if (this.loginType === "email") {
        form.userphone = this.form.userName;
        form.country_code = "";
        if (!emailReg.test(form.userphone)) {
          Toast(this.$t("emailFormatError"));
          return;
        }
      }
      this.$store.dispatch("login", form).then((res) => {
        if (!res || res.userphone !== res.realpass) return;
        Dialog.confirm({
          message: this.$t("密码强度比较低，请修改密码"),
          cancelButtonText: this.$t("user.Button.One"),
          confirmButtonText: this.$t("user.Button.Two"),
        }).then(() => {
          this.$router.push("/Password");
        }).catch(() => {});
      });
    },
    init() {
      let storePwdState = localStorage.getItem("the-pwd-state");
      let storePwd = localStorage.getItem("the-pwd-obj");
      this.$cookie.clear();
      this.$cookie.set("the-pwd-state", storePwdState);
      this.$cookie.set("the-pwd-obj", storePwd);
      let initObj = {
        userName: "",
        passwordL: "",
      };
      this.checked =
        storePwdState && storePwdState !== "undefined"
          ? JSON.parse(storePwdState)
          : false;
      this.form = storePwd
        ? JSON.parse(storePwd)
          ? JSON.parse(storePwd)
          : initObj
        : initObj;
    },
  },
  computed: {
    ...mapGetters(["theme"]),
  },
};
</script>

<style lang="less" scoped>
@checkbox-label-color: #88888d;
@Color: var(--theme);
@background: var(--bg);
@bg: var(--bg);
@sizeColor: var(--sizeColor);
@newbgColor: #272a29;

.wrap {
  min-height: calc(100vh - 40rem / 16);
  padding: calc(20rem / 16) calc(30rem / 16);
  background: var(--bgImg) no-repeat;
  background-size: 100% 100%;
  .logo_img{
    display: flex;
    justify-content: center;
    margin-top: 30px;
    img{
      width: 125px;
      display: block;
    }
  }
  .logo {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 10px 0;
    gap: 10px;
    .line{
      display: flex;
      align-items: center;
      .line_1{
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #e8e8e8;
        margin:0 -10px;
      }
      .line_2{
        width: 160px;
        height: 3px;
        background: #e8e8e8;
      }
    }
    .text{
      color: var(--white);
      font-size: 16px;
    }
  }

  .top_title {
    .title3 {
      font-size: calc(30rem / 16);
      color: var(--white);
      text-align: center;
      margin-top: 10px;

    }
  }

  .form_bar {
    padding: 0 calc(10rem / 16);
    border-radius: 16px;
    // padding-top: 40px;

    .inputs {
      .input_item {
        margin: calc(15rem / 16) 0 0;
        padding: 0;
        ._item {
          border-radius: 30px;
          background: var(--btnBg);
          padding-right: calc(10rem / 16);
          display: flex;
          align-items: center;
          border: 1px solid var(--black);

          input {
            border: 0;
            flex: 1;
            padding: 0;
            padding-left: calc(10rem / 16);
            font-size: calc(14rem / 16);
            height: calc(38rem / 16);
            line-height: calc(38rem / 16);
            background-color: transparent;
            color: var(--black);
            text-align: center;
          }

          input::placeholder {
            font-size: calc(14rem / 16);
            color: var(--inputPlaceholder);
            text-align: center;
          }

          .pwd_icons {
            color: var(--black);
          }
        }
      }
    }

    .btn_login {
      margin: calc(30rem / 16) auto calc(10rem / 16);
      color: var(--textColor);
      border-radius: calc(30rem / 16);
      height: calc(38rem / 16);
      font-size: calc(16rem / 16);
      text-align: center;
      width: fit-content;
      padding: 0 40px;
      line-height: calc(38rem / 16);
      border: 2px solid var(--black);
      background: var(--btnBg);
    }

    .tips {
      margin-top: calc(20rem / 16);
      font-size: calc(14rem / 16);
      color: var(--black);
      text-align: center;
      &_btn {
        text-decoration: underline;
        font-weight: 700;
        font-size: calc(16rem / 16);
      }
    }
  }

  .lan_bar {
    position: absolute;
    top: 6px;
    right: 6px;
  }
}
</style>
